import { StoreError } from '../../Types/StoreTypes';

export const SET_ERROR = 'SET_ERROR';
export const SET_ERROR_MESSAGE = 'SET_ERROR_MESSAGE';
export const SET_ERROR_STATUS = 'SET_ERROR_STATUS';
export const SET_ERROR_REDIRECT_COUNTER = 'SET_ERROR_REDIRECT_COUNTER';

export function setError(error: StoreError['error']) {
    return { type: SET_ERROR, payload: error };
}

export function setErrorMessage(errorMessage: StoreError['errorMessage']) {
    return { type: SET_ERROR_MESSAGE, payload: errorMessage };
}

export function setErrorStatus(status: StoreError['status']) {
    return { type: SET_ERROR_STATUS, payload: status };
}

export function setErrorRedirectCounter(counter: StoreError['errorRedirectCounter']) {
    return { type: SET_ERROR_REDIRECT_COUNTER, payload: counter };
}
